import { ipoConstants } from '../_constants/ipo.constants';
import {
  setIsFetching,
  filterIpoResults, 
  resetIpoResults, 
  sortType
} from '../_utils/ipo.utils';

const initialState = {
  ipos: {
    isFetching: false,
    ipoResults: [],
    errorMessage: null
  },
  detailModal: false,
  currentDetailModal: null,
  queries: {
    sortBy: null
  }
};

const ipoReducer = (state = initialState, action) => {
  switch (action.type) {
    case ipoConstants.FETCH_IPOS_START:
      return {
        ...state,
        ipos: setIsFetching(state.ipos)
      };
    case ipoConstants.FETCH_IPOS_SUCCESS:
      return {
        ...state,
        ipos: filterIpoResults(state.ipos, action.payload)
      };
    case ipoConstants.FETCH_IPOS_FAILURE:
      return {
        ...state,
        ipos: resetIpoResults(state.ipos, action.payload)
      };
    case ipoConstants.TOGGLE_DETAIL_MODAL:
      return {
        ...state,
        detailModal: !state.detailModal
      };
    case ipoConstants.SET_CURRENT_DETAIL_MODAL:
      return {
        ...state,
        currentDetailModal: action.payload
      };
    case ipoConstants.UPDATE_IPO_QUERIES:{
      if (!action.payload || !Object.keys(action.payload).length) {
        return state;
      }

      let updateAttribute = {};
      Object.keys(action.payload).forEach(attribute => {
        let value = action.payload[`${attribute}`];
        updateAttribute[attribute] = value;
      })

      return {
        ...state,
        queries: {
          ...state.queries,
          ...updateAttribute
        }
      };
    }
    default:
      return state;
  }
};

export default ipoReducer;
